import '../css/DeleteConfirm.css';
import Overlay from './Overlay.';

export default function DeleteConfirm(props) {
  const {
    active = true,
    message = '',
    cancelHandler,
    deleteHandler,
    inputMessage,
    buttonMessage
  } = props;

  return (
    <Overlay active={active}>
      <div className='delete-confirm'>
      <img src='/img/icon-cancel.png' alt='' className='w-25 d-block ms-auto me-auto'/>
        <h6 data-testid='dc-message' className='text-center my-3'>{message}</h6>
        {inputMessage}
        <div className='mt-3 d-flex justify-content-center'>
          <button data-testid='dc-cancel' className='btn btn-outline-primary me-3' onClick={cancelHandler}>Batal</button>
          <button data-testid='dc-delete' className='btn btn-outline-danger' onClick={deleteHandler}>{buttonMessage}</button>
        </div>
      </div>
    </Overlay>
  );
};